// Online 图表配置
<template>
  <div style="width: 100%; height: 100%; min-height: calc(100vh - 84px); padding: 20px; box-sizing: border-box;">
    <Table
      :tableData="tableData"
      :loading="false"
      :operateWidth="160"
      :tableHeader="tableHeader"
      :pagination="pagination"
      @pagination="changePagination"
      :slotArr="slotArr"
    >
      <!-- search 筛选框 -->
      <template slot="searchBox" v-if="false">
        <el-form class="flex_box" v-show="showSearch" :model="tableParams" ref="tableParams" :inline="true">
          <el-form-item v-for="(item, i) in tableSearch" :key="i" :label="item.label" prop="">
            <div class="input_box">
              <el-input v-model="tableParams[item.value]" :placeholder="'请输入' + item.name"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="onSearch">
              查询
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="reset">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </template>

      <template slot="btnBox">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="addItem">
              新增
            </el-button>
          </el-col>
          <right-toolbar :showSearch.sync="showSearch" @queryTable="getTableData"></right-toolbar>
        </el-row>
      </template>
      <!-- table 操作栏 -->
      <template slot="operation" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
          <el-button type="primary" plain icon="el-icon-edit" circle @click="editItem(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
          <el-button type="danger" plain icon="el-icon-delete" circle @click="deleteItem(scope.row)"></el-button>
        </el-tooltip>
      </template>
    </Table>

    <el-dialog :title="title === 1 ? '新增' : '编辑'" :visible.sync="dialogVisible" @close="diaClose" top="0" class="dia_box">
      <!-- width="90%" -->
      <AddOrEdit v-if="title" @diaClose="diaClose" @onAdd="onAdd" @onUpdate="onUpdate" :row="row" />
    </el-dialog>
  </div>
</template>
<script>
import Table from "@/components/MyTable";
export default {
  name: "People",
  components: {
    Table,
    AddOrEdit: () => import("./compontent/AddOrEdit.vue")
  },
  data() {
    return {
      showSearch: true,
      slotArr: [{ slotname: "headBox" }, { slotname: "searchBox", className: "search_box" }, { slotname: "btnBox", className: "" }],

      tableData: [],
      tableHeader: [
        { label: "视图名称", prop: "name" },
        { label: "操作", prop: "", slotname: "operation" }
      ],
      // table 筛选条件
      tableParams: {},
      tableSearch: [],

      pagination: {
        size: 10,
        total: 0,
        page: 1
      },
      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、详情
      row: {},

      lineArr: [],
      pointArr: [],
      appId: null
    };
  },
  created() {
    this.tableHeader.forEach(el => {
      if (el.search) {
        this.tableParams[el.prop] = null;
        this.tableSearch.push({
          name: el.label,
          value: el.prop
        });
      }
    });
  },
  mounted() {
    this.appId = this.$route.query.appId;
    this.getTableData();
  },
  methods: {
    changePagination(par) {
      this.pagination = {
        ...this.pagination,
        ...par
      };
      this.getTableData();
    },
    async getTableData() {
      const params = {
        ...this.tableParams,
        pageSize: this.pagination.size,
        pageNum: this.pagination.page,
        appId: this.appId
      };
      this.loading = true;
      const { rows, total } = await this.$api.getChartsViewPage(params);
      this.loading = false;
      this.tableData = rows;
      this.pagination.total = total;
    },

    // 重置
    reset() {
      this.tableParams = {};
      this.getTableData();
    },
    addItem() {
      this.row = {};
      this.title = 1;
      this.dialogVisible = true;
    },
    editItem(row) {
      this.row = row;
      this.title = 2;
      this.dialogVisible = true;
    },
    diaClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.title = null;
      }, 100);
    },

    // 新增
    async onAdd(params) {
      await this.$api.AddChartsView(params);
      this.$message({
        message: "新增成功",
        type: "success"
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 更新
    async onUpdate(params) {
      await this.$api.UpdateChartsView(params);
      this.$message({
        message: "更新成功",
        type: "success"
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 删除
    async onDel(row) {
      await this.$api.DelChartsView({ id: row.id });
      this.$message({
        message: "删除成功",
        type: "success"
      });
      this.getTableData();
    },

    deleteItem(row) {
      this.$alert("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action == "confirm") {
            this.onDel(row);
          }
        }
      });
    },

    toPreview(row) {
      this.$router.push({
        path: "/preview",
        query: { id: row.id }
      });
    },
    toDataModel(row) {
      this.$router.push({
        path: "/tool/DataBoardDataModel",
        query: { id: row.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dia_box {
  width: 100%;
  height: 100%;

  ::v-deep {
    .el-dialog {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
